import CheckoutLegalOptIn from 'components/FrictionlessCheckout/AutoReplenish/CheckoutLegalOptIn/CheckoutLegalOptIn';
import withGlobalModals from 'hocs/withGlobalModals';
import { connect } from 'react-redux';
import { createSelector, createStructuredSelector } from 'reselect';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import FrameworkUtils from 'utils/framework';
import OrderActions from 'actions/OrderActions';
import { orderSelector } from 'selectors/order/orderSelector';
import CheckoutLegalOptInEN from 'components/FrictionlessCheckout/AutoReplenish/CheckoutLegalOptIn/locales/CheckoutLegalOptIn_en_US';
import CheckoutLegalOptInFR from 'components/FrictionlessCheckout/AutoReplenish/CheckoutLegalOptIn/locales/CheckoutLegalOptIn_fr_CA';

const { wrapHOC } = FrameworkUtils;
const { getTextFromResource, getLocalisedDataFromResource } = LanguageLocaleUtils;
const getText = getLocalisedDataFromResource(CheckoutLegalOptInEN, CheckoutLegalOptInFR);

const withCheckoutLegalOptInProps = wrapHOC(
    connect(
        createSelector(
            orderSelector,
            createStructuredSelector({
                termsOfUse: getTextFromResource(getText, 'termsOfUse'),
                andText: getTextFromResource(getText, 'andText'),
                privacyPolicy: getTextFromResource(getText, 'privacyPolicy'),
                iAgreeToAutoReplenish: getTextFromResource(getText, 'iAgreeToAutoReplenish'),
                termsAndConditions: getTextFromResource(getText, 'termsAndConditions'),
                forTheSubscription: getTextFromResource(getText, 'forTheSubscription'),
                byClickingPlaceOrder: getTextFromResource(getText, 'byClickingPlaceOrder'),
                andConditionsOfUseHaveRead: getTextFromResource(getText, 'andConditionsOfUseHaveRead'),
                confirmText: getTextFromResource(getText, 'confirmText'),
                autoReplenishSub: getTextFromResource(getText, 'autoReplenishSub'),
                consentText: getTextFromResource(getText, 'consentText')
            }),
            (order, textResources) => {
                const { acceptAutoReplenishTerms, confirmVerbalConsent } = order;

                return {
                    acceptAutoReplenishTerms,
                    confirmVerbalConsent,
                    ...textResources
                };
            }
        ),
        {
            updateSephoraTerms: OrderActions.updateSephoraTerms,
            updateAutoReplenishTerms: OrderActions.updateAutoReplenishTerms,
            updateVerbalConsent: OrderActions.updateVerbalConsent
        }
    )
);

const ConnectedCheckoutLegalOptIn = withGlobalModals(withCheckoutLegalOptInProps(CheckoutLegalOptIn));

export default ConnectedCheckoutLegalOptIn;
